import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { appTooltipProps } from '../../utils';
import CircularProgress from '../CircularProgress';
import Row from '../display/Row';
import SvgColorImg from '../SvgColorImg';

const OvalButton = function OvalButton(props) {
  const {
    className,
    onClick,
    label,
    disabled,
    id,
    color = 'main',
    absolute,
    div,
    busy,
    // eslint-disable-next-line no-unused-vars
    redDot,
    framed,
    imgSrc,
    imgRight,
    small,
    name,
    tooltipTxt,
  } = props;
  const [animate, setAnimate] = useState(false);

  const divClassname = classNames(
    'shrink-0 flex gap-2 items-center justify-center relative rounded-3xl font-semibold whitespace-nowrap',
    {
      absolute,
      'h-11 text-base px-4': !small,
      'h-9 text-sm px-2.5': small,
      'relative': !absolute,
      'opacity-50': disabled,
      'drop-shadow-md': (!disabled) && (!framed),
      // Button color:
      'bg-pxPrimary text-white': (color === 'main'),
      'bg-pxSecondary text-white': (color === 'secondary'),
    },
    className,
  );

  const onClickAnimate = (event) => {
    setAnimate(true);
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
    onClick(event);
  };

  let busyOverlay;
  if (busy) {
    busyOverlay = (
      <Row className="absolute w-full h-full">
        <CircularProgress className="h-8" />
      </Row>
    );
  }

  const img = (imgSrc)
    ? (
        <SvgColorImg
          src={imgSrc}
          className={classNames(
            'h-5 w-5 shrink-0 fill-white',
          )}
          imgColorAsCssFill
        />
      )
    : null;

  //
  // Inactive button
  //
  if (div) {
    return (
      <div
        className={divClassname}
        id={id}
      >
        {imgRight ? null : img }
        {label}
        {imgRight ? img : null}
        {busyOverlay}
      </div>
    );
  }

  //
  // Regular button
  //
  return (
    <button
      type="button"
      onClick={onClickAnimate}
      onMouseDown={() => { setAnimate(true); }}
      onTouchStart={() => { setAnimate(true); }}
      className={divClassname}
      disabled={disabled}
      id={id}
      name={name}
      {...appTooltipProps(tooltipTxt)}
    >
      {imgRight ? null : img }
      {label}
      {imgRight ? img : null}
      {busyOverlay}

      <div
        className={classNames(
          'absolute top-0 left-0 w-full h-full scale-0 opacity-0 bg-white rounded-full border-0',
          {
            'animate-ripple': animate,
          },
        )}
        onAnimationEnd={() => {
          // console.log('end ripple');
          setAnimate(false);
        }}
      />

      {/* { (redDot)
        ? <GlowingDot absolute className="top-0 left-0" />
        : null} */}
    </button>
  );
};

OvalButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  color: PropTypes.string,
  absolute: PropTypes.bool,
  div: PropTypes.bool,
  busy: PropTypes.bool,
  redDot: PropTypes.bool,
  framed: PropTypes.bool,
  imgSrc: PropTypes.string,
  imgRight: PropTypes.bool,
  small: PropTypes.bool,
  name: PropTypes.string,
  tooltipTxt: PropTypes.string,
};

export default OvalButton;
